export default __webpack_public_path__ + "static/media/status-icon-sprite.4fee9fefc3971799d2dd4de0a15617f0.svg";